// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"67147ff5","285":"84d47b65","420":"7e2f10de","444":"d59ae61b","499":"b3312039","526":"3ed48ce8","649":"0988e5f4","703":"bf7ca5b5","733":"adc79a3c","801":"228b7fe3","806":"631eca6c","940":"58f9ee44","965":"b78142ba","997":"3afb2527"}[chunkId] + ".chunk.js";
};